<template>
  <div id="SettingPage" class="section">
    <div class="columns is-multiline has-text-left">
      <div class="column is-12">
        <h1 class="title">MY PROFILE</h1>
      </div>
    </div>
    <div class="container" style="margin-top: 1.5rem">
      <div class="column is-12 has-text-left">
        <div class="columns is-multiline is-mobile">
          <div class="column is-2">
            <p>Full Name:</p>
          </div>
          <div class="column is-10">
            <p>
              {{ user_profile.name }}
            </p>
          </div>
          <div class="column is-2">
            <p>Username:</p>
          </div>
          <div class="column is-10">
            <p>
              {{ user_profile.username }}
            </p>
          </div>
          <div class="column is-2">
            <p>Email:</p>
          </div>
          <div class="column is-10">
            <p>
              {{ user_profile.email }}
            </p>
          </div>
          <div class="column is-2">
            <p>Role:</p>
          </div>
          <div class="column is-10">
            <p>
              {{ user_profile.role }}
            </p>
          </div>
          <div class="column is-2">
            <p>Unit:</p>
          </div>
          <div class="column is-10">
            <p v-if="business_unit">
              {{ business_unit }}
            </p>
          </div>
          <div class="column is-6">
            <b-button
              outlined
              type="is-primary"
              @click.prevent="presentChangePasswordForm()"
              >Change Password</b-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BusinessUnitApi from "@/services/BusinessUnitApi";

import Helpers from "@/utils/Helper";
import AlertManager from "@/utils/AlertManager";
import ChangePasswordForm from "@/components/forms/ChangePasswordForm.vue";

export default {
  name: "SettingPage",
  data() {
    return {
      business_unit: null
    };
  },
  computed: mapState(["user_profile"]),
  methods: {
    presentChangePasswordForm: function() {
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        component: ChangePasswordForm,
        props: {
          user_id: this.user_profile_id
        }
      });
    },
    requestGetBusinessUnitList: async function() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const response = await BusinessUnitApi.requestBusinessUnitList();
      loadingComponent.close();
      if (response.status) {
        const found = Helpers.mappingBusinessUnitById(
          response.payload,
          this.user_profile.business_unit
        );
        this.business_unit = found.business_unit_name;
      } else {
        AlertManager.showErrorSnackbar(response.message);
      }
    }
  },
  async beforeMount() {
    await this.requestGetBusinessUnitList();
  }
};
</script>

<style></style>
